var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","d":"M5 12h14m-7-7l7 7-7 7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }